import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography } from "@material-ui/core";
import { useTheme } from "@material-ui/core/styles";
import styled from "styled-components";

const FleetSettingsGrid = styled(Grid)`
  border-bottom: 1px solid ${(props) => props.theme.palette.primary.divider};
  margin-bottom: 8px;
  &:last-child {
    margin-bottom: 0;
    border-bottom: none;
  }
`;

const FleetSettingsSection = (props) => {
  const theme = useTheme();
  const { heading, children } = props;

  const childProps = Object.entries(props).reduce((final, [k, v]) => {
    if (["heading", "children"].includes(k)) return final;
    final[k] = v;
    return final;
  }, {});

  return (
    <FleetSettingsGrid theme={theme} {...childProps}>
      {heading && (
        <Grid item xs={12}>
          <Typography variant="h5">{heading}</Typography>
        </Grid>
      )}
      {children}
    </FleetSettingsGrid>
  );
};

FleetSettingsSection.propTypes = {
  heading: PropTypes.string,
  children: PropTypes.array,
};

FleetSettingsSection.defaultProps = {
  heading: null,
  children: [],
};

export default FleetSettingsSection;
